










import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'LoadingDialog',
  props: {
  },
  data() {
    return {
      modal: false,
      speed: 0,
    };
  },
  async mounted() {
    this.speed = 0;
    while (this.speed < 5) {
      await this.wait(2);
      this.speed++;
    }
  },
  methods: {
    async wait(second: number) {
      return new Promise((resolve) => setTimeout(() => resolve(true), 1000 * second));
    },
  },
});

